import { Routes } from "@angular/router";

// Dev/staging-only playground for new-UI (BCAD-529) components awaiting page integration.
// The production build swaps this file for test.routes.prod.ts (angular.json fileReplacements),
// so the playground's lazy chunk is never created in the production bundle (FLIP-562).
export const TEST_ROUTES: Routes = [
  {
    path: "test",
    loadComponent: () =>
      import("./test.component").then((m) => m.TestComponent),
  },
];
